import React from 'react';
import LoadingSpinner from 'components/LoadingSpinner';

import useCropZoneData from 'screens/Property/hooks/useCropZoneData';
import useFieldData from 'screens/Property/hooks/useFieldData';

export interface PropertyNameCellProps {
  property: {
    id?: string;
    name?: string;
    cropzoneId?: string;
  };
}

// Both hooks are untyped JS holding their data in a bare useState(), so TS
// infers `never` for what they return. Declare only the fields this cell reads.
interface CropZoneData {
  cropZone?: { fieldId?: string };
}
interface FieldData {
  field?: { name?: string };
  loading?: boolean;
}

const PropertyNameCell = ({ property }: PropertyNameCellProps) => {
  const { cropZone } = useCropZoneData(property?.cropzoneId) as CropZoneData;
  const { field, loading } = useFieldData(cropZone?.fieldId) as FieldData;

  if (loading) {
    return (
      <LoadingSpinner message="" size={16} inline label="Loading field name" />
    );
  }

  return (
    <span className="flex flex-col">
      <span
        className="w-64 pb-2 text-sm font-bold text-left truncate"
        data-testid="property-name"
      >
        {field?.name}
      </span>
      <span
        className="w-64 text-sm text-left text-gray-600 truncate"
        data-testid="property-manufacturer"
      >
        {property?.name}
      </span>
    </span>
  );
};

export default PropertyNameCell;
